var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-reports-main__table-cell page-admin-reports-main__table-cell-load-time",class:{
    'page-admin-reports-main__table-cell_negative': _vm.isNegativeLoadTime,
  }},[_vm._v(" "+_vm._s(_vm.formattedLoadTime)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.isUnlimitedLoadTime)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }